var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"app-link",attrs:{"to":_vm.to},on:{"click":function($event){$event.preventDefault();}}},[_vm._t("default"),_c('span',{staticClass:"app-link__text"},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }